import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container my-25 max-w-[1312px] max-md:my-15',
    title: 'heading-3xl-desk max-md:heading-3xl mb-4',
    description:
      'heading-l-block max-md:heading-m-block mb-12 max-w-[1075px] max-md:mb-8',
    levels: 'flex gap-6 max-md:gap-4 max-sm:flex-col',
    level: 'flex-1'
  }
});
